import { createRouteRef } from "@backstage/core-plugin-api";

export const pluginId = "k8s-dashboard";

export const rootRouteRef = createRouteRef({
    id: pluginId,
});
